import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { K2SocleAllActiveTasks,K2Api, K2Apis } from './models/K2Model';

@Injectable({
  providedIn: 'root'
})
export class K2Service {
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    this.apiUrl=appConfig.K2SocleServiceUrl;
   }

  getAllActiveTask(url):Observable<K2SocleAllActiveTasks[]> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-all-active-tasks`, url) as Observable<K2SocleAllActiveTasks[]>;
    return this.apiService.response(data,K2SocleAllActiveTasks,'all-active-tasks') as Observable<K2SocleAllActiveTasks[]>;
  }
  getK2Isa(url):Observable<K2Apis> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-k2-isa`, url) as Observable<K2Apis>;
    return this.apiService.response(data,K2Apis,'listRequestDetails') as Observable<K2Apis>;
  }
  getK2IsabyId(url):Observable<K2Api> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-k2-isa`, url) as Observable<K2Api>;
    return this.apiService.response(data,K2Api,'listRequestDetails') as Observable<K2Api>;
  }
  createK2Isa(url,data):Observable<any> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-k2-isa`, url,data) as Observable<any>;
  }
  updateK2Task(url,data):Observable<any> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-k2-tasks`, url,data) as Observable<any>;
  }
}
